import {getContangoEmbedToken} from '../../../apis/premier-plus-api';
import {handleApiError} from '../../../shared/actions';

export const fetchContangoEmbedToken = () => (async (dispatch, getState) => {
  dispatch({
    type: 'MARKETING_PLAN_EMBED_TOKEN_FETCH_STARTED',
  });
  const {growerId} = getState().auth.authorization;
  var response = null;
  try {
    response = await getContangoEmbedToken(growerId);
  }
  catch (errorCode) {
    dispatch({
      type: 'MARKETING_PLAN_EMBED_TOKEN_FETCH_FAILED',
    });
    dispatch(handleApiError(errorCode));
    return;
  }
  dispatch({
    type: 'MARKETING_PLAN_EMBED_TOKEN_FETCH_SUCCEEDED',
    embedToken: response.body.embedToken,
  });
});
